import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HeaderComponent} from './components/header/header.component';
import {FooterComponent} from './components/footer/footer.component';
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {HttpClient, HttpClientModule} from "@angular/common/http";
import {TranslateCompiler, TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {TranslateMessageFormatCompiler} from "ngx-translate-messageformat-compiler";
import {NgxMaskDirective, NgxMaskPipe, provideNgxMask} from "ngx-mask";
import {FormsModule} from "@angular/forms";
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import {MelodyItemComponent} from './components/melody-item/melody-item.component';
import {MobileAppsBannerComponent} from './components/banners/mobile-apps-banner/mobile-apps-banner.component';
import {PrivetPlusBannerComponent} from './components/banners/privet-plus-banner/privet-plus-banner.component';
import {MainPageComponent} from './pages/main-page/main-page.component';
import {ArtistPageComponent} from './pages/artist-page/artist-page.component';
import {NgOptimizedImage} from '@angular/common';
import {MelodyPageComponent} from './pages/melody-page/melody-page.component';
import {HeaderMenuComponent} from './components/header-menu/header-menu.component';
import {ReplaceMissingImageDirective} from "./components/directives/replace-missing-image.directive";
import {HeaderArtistItemComponent} from './components/header-artist-item/header-artist-item.component';
import {MainPageBannerComponent} from './components/banners/main-page-banner/main-page-banner.component';
import {MelodyItemSliderComponent} from './components/melody-item-slider/melody-item-slider.component';
import {GenresPageComponent} from './pages/genres-page/genres-page.component';
import {Page404Component} from './pages/error-pages/page-404/page-404.component';
import {Page500Component} from './pages/error-pages/page-500/page-500.component';
import {httpErrorsInterceptorProvider} from "./interceptors/http-errors.interceptor";
import {Page505Component} from './pages/error-pages/page-505/page-505.component';
import {ModalsBlockComponent} from './components/modals-block/modals-block.component';
import {AuthModalComponent} from './modals/auth-modal/auth-modal.component';
import {LogoutModalComponent} from './modals/logout-modal/logout-modal.component';
import {authInterceptorProvider} from "./interceptors/auth.interceptor";
import {HitMelodiesComponent} from './components/hit-melodies/hit-melodies.component';
import {GiftMelodyModalComponent} from './modals/gift-melody-modal/gift-melody-modal.component';
import {PurchaseMelodyModalComponent} from './modals/purchase-melody-modal/purchase-melody-modal.component';
import {TopLineComponent} from './components/top-line/top-line.component';
import {SubscriptionsPageComponent} from './pages/subscriptions-page/subscriptions-page.component';
import {SubscriberMelodiesPageComponent} from './pages/subscriber-melodies-page/subscriber-melodies-page.component';
import {SubscriberFavoritesComponent} from './pages/subscriber-favorites/subscriber-favorites.component';
import {SubscriberMelodyItemComponent} from './components/subscriber-melody-item/subscriber-melody-item.component';
import {SubscriberMelodySettingsModalComponent} from './modals/subscriber-melody-settings-modal/subscriber-melody-settings-modal.component';
import {DeleteMelodyModalComponent} from './modals/delete-melody-modal/delete-melody-modal.component';
import {ActivateSubscriptionModalComponent} from './modals/activate-subscription-modal/activate-subscription-modal.component';
import {DeactivateSubscriptionModalComponent} from './modals/deactivate-subscription-modal/deactivate-subscription-modal.component';
import {SubscriptionInfoModalComponent} from './modals/subscription-info-modal/subscription-info-modal.component';
import {SubscriberRulesPageComponent} from './pages/subscriber-rules-page/subscriber-rules-page.component';
import {ContactItemComponent} from './components/contact-item/contact-item.component';
import {GroupItemComponent} from './components/group-item/group-item.component';
import {GenresSliderComponent} from './components/genres-slider/genres-slider.component';
import {EditContactModalComponent} from './modals/edit-contact-modal/edit-contact-modal.component';
import {ContactInfoModalComponent} from './modals/contact-info-modal/contact-info-modal.component';
import {GroupInfoModalComponent} from './modals/group-info-modal/group-info-modal.component';
import {EditGroupModalComponent} from './modals/edit-group-modal/edit-group-modal.component';
import {RulesBlockComponent} from './components/rules-block/rules-block.component';
import {ContactsSelectComponent} from './components/contacts-select/contacts-select.component';
import {DeleteContactModalComponent} from './modals/delete-contact-modal/delete-contact-modal.component';
import {DeleteGroupModalComponent} from './modals/delete-group-modal/delete-group-modal.component';
import {MobileAppsPageComponent} from './pages/mobile-apps-page/mobile-apps-page.component';
import {UssdCommandsPageComponent} from './pages/ussd-commands-page/ussd-commands-page.component';
import {PrivacyPageComponent} from './pages/privacy-page/privacy-page.component';
import {OfferPageComponent} from './pages/offer-page/offer-page.component';
import {SubscriberUgcPageComponent} from './pages/subscriber-ugc-page/subscriber-ugc-page.component';
import {UgcUploadedModalComponent} from './modals/ugc-uploaded-modal/ugc-uploaded-modal.component';
import {environment} from "../environments/environment";
import {ChooseSubscriptionModal} from "./modals/choose-subscription-modal/choose-subscription-modal";
import {MainPageSubscriptionSelectComponent} from "./components/main-page-subscription-select/main-page-subscription-select.component";
import {MetrikaModule} from "ng-yandex-metrika";
import {AutoradioVisibilityDirective} from "./components/directives/autoradio-visibility-directive";

@NgModule({
  declarations: [
    AppComponent,
    AutoradioVisibilityDirective,
    ReplaceMissingImageDirective,
    HeaderComponent,
    FooterComponent,
    MelodyItemComponent,
    MobileAppsBannerComponent,
    PrivetPlusBannerComponent,
    MainPageComponent,
    ArtistPageComponent,
    MelodyPageComponent,
    HeaderMenuComponent,
    HeaderArtistItemComponent,
    MainPageBannerComponent,
    MelodyItemSliderComponent,
    GenresPageComponent,
    Page404Component,
    Page500Component,
    Page505Component,
    ModalsBlockComponent,
    AuthModalComponent,
    LogoutModalComponent,
    HitMelodiesComponent,
    GiftMelodyModalComponent,
    PurchaseMelodyModalComponent,
    TopLineComponent,
    SubscriptionsPageComponent,
    SubscriberMelodiesPageComponent,
    SubscriberFavoritesComponent,
    SubscriberMelodyItemComponent,
    SubscriberMelodySettingsModalComponent,
    DeleteMelodyModalComponent,
    ActivateSubscriptionModalComponent,
    DeactivateSubscriptionModalComponent,
    SubscriptionInfoModalComponent,
    SubscriberRulesPageComponent,
    ContactItemComponent,
    GroupItemComponent,
    GenresSliderComponent,
    EditContactModalComponent,
    ContactInfoModalComponent,
    GroupInfoModalComponent,
    EditGroupModalComponent,
    RulesBlockComponent,
    ContactsSelectComponent,
    DeleteContactModalComponent,
    DeleteGroupModalComponent,
    MobileAppsPageComponent,
    UssdCommandsPageComponent,
    PrivacyPageComponent,
    OfferPageComponent,
    SubscriberUgcPageComponent,
    UgcUploadedModalComponent,
    ChooseSubscriptionModal,
    MainPageSubscriptionSelectComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      },
      compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler
      },
      defaultLanguage: "ru"
    }),
    NgxMaskDirective,
    NgxMaskPipe,
    FormsModule,
    InfiniteScrollModule,
    NgOptimizedImage,
    MetrikaModule.forRoot({
      id: environment.yaMetrics
    })
  ],
  providers: [
    provideNgxMask(),
    authInterceptorProvider,
    httpErrorsInterceptorProvider
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '/i18n/', '.json');
}
